export default "__VITE_ASSET__Cj9us9X6__"